<template>
  <div class="row">
    <div class="col-lg-12 col-xxl-12">
      <div class="card card-custom card-stretch gutter-b">
        <div class="card-body p-0 border-0">
          <div class="card-toolbar">
            <b-carousel id="carousel-1" :interval="4000" :controls="banner_images.length > 1"
              :indicators="banner_images.length > 1" background="#FFF" style="text-shadow: 1px 1px 2px #333;">
              <b-carousel-slide v-for="image_path in banner_images" :key="image_path.id"
                :img-src="image_path.image"></b-carousel-slide>
            </b-carousel>
          </div>
        </div>
      </div>
    </div>

    <div v-if="campaigns.length" class="col-lg-12 col-xxl-12">
      <div class="card card-custom card-stretch gutter-b">
        <div class="card-body border-0 py-5">
          <div class="card-toolbar">
            <div class="col-lg-12 col-xxl-12 p-0">
              <div class="card card-custom gutter-b p-5">
                <div class="row">
                  <div div class="col-lg-4 align-self-center">
                    <b-form-group id="name-input-group" class="mb-0" label="เลือกแคมเปญ" label-for="name-input"
                      label-cols="3" label-align-sm="left" label-size="lg">
                      <model-select :options="campaigns_option" v-model="item" placeholder="" @input="onSelect">
                      </model-select>
                    </b-form-group>
                  </div>
                  <div class="col-lg-2 align-self-center text-center">
                    <span v-if="campaign_id" class="status-campaign">สถานะ
                    </span>
                    <span v-if="campaign_id" class="status-campaign"
                      :class="campaign.is_active ? 'active' : 'deactive'">{{ campaign.is_active ? "เปิด" : "ปิด" }}</span>
                    <!-- <span style="color:red;font-weight:bold;">ปิด</span> -->
                  </div>
                  <div class="col-lg-3 align-self-center text-center">
                    <span v-if="campaign_id" style="text-decoration:underline;font-weight:bold;">เริ่มต้น {{ start_date }}
                    </span>
                    <!-- <span style="color:red;font-weight:bold;">ปิด</span> -->
                  </div>
                  <div class="col-lg-3 align-self-center text-center">
                    <span v-if="campaign_id" style="text-decoration:underline;font-weight:bold;">สิ้นสุด {{ end_date }}
                    </span>
                    <!-- <span style="color:red;font-weight:bold;">ปิด</span> -->
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-8">
              <div class="col-lg-3 col-xxl-3">
                <div class="card card-custom gutter-b" style="height: 150px">
                  <div class="card-body">
                    <span class="svg-icon svg-icon-3x svg-icon-primary">
                      <inline-svg src="media/svg/icons/Home/Clock.svg" />
                    </span>
                    <div class="text-dark font-weight-bolder font-size-h2 mt-3">
                      {{ customerCampaign1HourBack }}
                    </div>
                    <a href="#" class="text-muted text-hover-primary font-weight-bold font-size-lg mt-1">
                      {{
                        $t(
                          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.CUSTOMER_PER_HOUR"
                        )
                      }}
                    </a>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-xxl-3">
                <div class="card card-custom gutter-b" style="height: 150px">
                  <div class="card-body">
                    <span class="svg-icon svg-icon-3x svg-icon-primary">
                      <inline-svg src="media/svg/icons/General/Star.svg" />
                    </span>
                    <div class="text-dark font-weight-bolder font-size-h2 mt-3">
                      {{ customerCampaignToDay }}
                    </div>
                    <a href="#" class="text-muted text-hover-primary font-weight-bold font-size-lg mt-1">
                      {{
                        $t(
                          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.CURRENT_CUSTOME"
                        )
                      }}
                    </a>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-xxl-3">
                <div class="card card-custom gutter-b" style="height: 150px">
                  <div class="card-body">
                    <span class="svg-icon svg-icon-3x ml-n2">
                      <inline-svg src="media/svg/icons/General/User.svg" />
                    </span>
                    <b-button id="popover-button-sync" class="float-right btn btn-default btn-circle">
                      <i class="fa fa-info"></i>
                    </b-button>

                    <b-popover target="popover-button-sync">
                      จำนวนผู้ส่งใบเสร็จทั้งหมดตลอดระยะเวลากิจกรรม
                      โดยนับจากจำนวนคน ไม่ได้นับจำนวนใบเสร็จที่ส่ง
                    </b-popover>

                    <div class="font-weight-bolder font-size-h2 mt-3">
                      {{ customerCampaignAllTime }}
                    </div>

                    <a href="#" class="text-muted text-hover-primary font-weight-bold font-size-lg mt-1">
                      {{
                        $t(
                          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.CUSTOMER_PER_CAMPAIGN"
                        )
                      }}
                    </a>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-xxl-3">
                <div class="card card-custom bg-primary gutter-b" style="height: 150px">
                  <div class="card-body">
                    <span class="svg-icon svg-icon-3x svg-icon-white ml-n2">
                      <inline-svg src="media/svg/icons/General/User.svg" />
                    </span>

                    <b-button id="popover-button" class="float-right btn btn-default btn-circle">
                      <i class="fa fa-info"></i>
                    </b-button>

                    <b-popover target="popover-button">
                      จำนวนผู้ลงทะเบียน คือ
                      จำนวนคนที่กรอกหน้าลงทะเบียนเข้าร่วมกิจกรรมทั้งหมด
                      ซึ่งจะประกอบด้วยคนที่ส่งใบเสร็จและไม่ส่งใบเสร็จ
                    </b-popover>

                    <div class="text-inverse-primary font-weight-bolder font-size-h2 mt-3">
                      {{ total_customer_register }}
                    </div>
                    <a href="#" class="text-inverse-primary text-hover-primary font-weight-bold font-size-lg mt-1">
                      {{
                        $t(
                          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.CAMPAIGN_CUSTOMER_REGISTER"
                        )
                      }}
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12 col-xxl-12">
                <div class="card card-custom gutter-b p-5">
                  <div class="row">
                    <div class="col-lg-5 col-xxl-5">
                      <label for="">
                        {{
                          $t(
                            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.FROM"
                          )
                        }}
                      </label>
                      <date-picker v-model="from" :config="options"></date-picker>
                    </div>

                    <div class="col-lg-5 col-xxl-5">
                      <label for="">{{
                        $t(
                          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.TO"
                        )
                      }}</label>
                      <date-picker v-model="to" :config="options"></date-picker>
                    </div>

                    <div class="col-lg-2 col-xxl-2 pt-8 pb-3">
                      <b-button class="float-right" type="submit" variant="primary"
                        @click.prevent="filterGraph(campaign_id)">
                        {{
                          $t(
                            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.SEARCH"
                          )
                        }}
                      </b-button>
                    </div>
                  </div>

                  <div class="row my-5">
                    <div class="col-lg-12 col-xxl-12">
                      <RegPerDayLineChart :data="regPerDayLineChartData" :key="regPerDayLineChartKey" />
                    </div>
                  </div>

                  <div class="row my-5">
                    <div class="col-lg-12 col-xxl-12">
                      <CampaignLineChart :data="campaignLineChartData" :key="campaignLineChartKey" />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-6 col-xxl-6">
                      <div class="chartContainer p-5">
                        <ReceiptDonutChart :data="{
                          labels: this.donutChartData.receiptLable,
                          series: this.donutChartData.receiptDonutSeries,
                          colors: this.donutChartData.receiptColor
                        }" :key="donutChartKey" />
                      </div>
                    </div>

                    <div class="col-lg-6 col-xxl-6">
                      <div class="chartContainer p-5">
                        <UnapproveDonutChart :data="{
                          labels: this.donutChartData
                            .campaignReceiptUnapproveLable,
                          series: this.donutChartData
                            .campaignReceiptUnapproveDonutSeries
                        }" :key="donutChartKey" />
                      </div>
                    </div>

                    <div v-if="campaign.is_redeem_reward" class="col-lg-6 col-xxl-6">
                      <div class="chartContainer p-5">
                        <RewardDonutChart :data="{
                          labels: this.donutChartData
                            .campaignRedeemRewardLable,
                          series: this.donutChartData
                            .campaignRedeemRewardDonutSeries
                        }" :key="donutChartKey" />
                      </div>
                    </div>
                    <div v-else-if="campaign.template != 'funo/funo-002'" class="col-lg-6 col-xxl-6">
                      <div class="chartContainer p-5">
                        <ReceiptRewardDonutChart :data="{
                          labels: this.donutChartData.campaignReceiptRewardLable,
                          series: this.donutChartData.campaignReceiptRewardDonutSeries
                        }" :key="donutChartKey" />
                      </div>
                    </div>
                    <div class="col-lg-6 col-xxl-6">
                      <div class="chartContainer p-5">
                        <ReceiptRewardPointDonutChart :data="{
                          labels: this.donutChartData
                            .campaignReceiptRewardPointLable,
                          series: this.donutChartData
                            .campaignReceiptRewardPointDonutSeries
                        }" :key="donutChartKey" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="col-lg-12 col-xxl-12">
      <div class="card card-custom card-stretch gutter-b">
        <div class="card-body p-5 border-0">
          <div class="card-toolbar">
            <div class="p-5 text-center">
              <h2>ยังไม่มีข้อมูลกิจกรรม</h2>

              <div class="mt-5">
                <a href="/#/campaign/form/campaign_receipt">สร้างข้อมูลกิจกรรม</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.btn-circle {
  width: 20px;
  height: 20px;
  padding: 0px 0px;
  border-radius: 15px;
  text-align: center;
  font-size: 8px;
  line-height: 1.42857;
}

.chartContainer {
  margin: 15px 0;
  border: solid 1px #e8e8e8;
  border-radius: 0.42rem;
}

.chartContainer .apexcharts-tooltip {
  color: #111;
}

.chartContainer .apexcharts-tooltip .apexcharts-tooltip-series-group.active {
  background: #111 !important;
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { GET_ALL } from "@/core/services/store/banner.module";
import { GET_CAMPAIGN } from "@/core/services/store/campaign.module";
import { Config } from "@/core/config/variable.config";
import Swal from "sweetalert2";
import { ModelSelect } from "vue-search-select";
import datePicker from "vue-bootstrap-datetimepicker";
import {
  DASHBOARD_CHART_CAMPAIGN,
  DASHBOARD_CUSTOMER_LINE_CHART_CAMPAIGN,
  DASHBOARD_REG_PER_DAY_LINE_CHART_CAMPAIGN
} from "@/core/services/store/campaign.module";
import RegPerDayLineChart from "@/view/pages/chart/RegPerDayLineChart";
import CampaignLineChart from "@/view/pages/chart/CampaignLineChart";
import ReceiptDonutChart from "@/view/pages/chart/ReceiptDonutChart";
import UnapproveDonutChart from "@/view/pages/chart/UnapproveDonutChart";
import RewardDonutChart from "@/view/pages/chart/RewardDonutChart";
import ReceiptRewardDonutChart from "@/view/pages/chart/ReceiptRewardDonutChart";
import ReceiptRewardPointDonutChart from "@/view/pages/chart/ReceiptRewardPointDonutChart";

export default {
  name: "Dashboard",
  components: {
    ModelSelect,
    datePicker,
    RegPerDayLineChart,
    CampaignLineChart,
    ReceiptDonutChart,
    UnapproveDonutChart,
    RewardDonutChart,
    ReceiptRewardDonutChart,
    ReceiptRewardPointDonutChart
  },
  data() {
    return {
      from: null,
      to: null,
      campaign_id: null,
      options: {
        useCurrent: false,
        locale: "th",
        icons: {
          time: "fas fa-clock",
          date: "far fa-calendar",
          up: "fas fa-arrow-up",
          down: "fas fa-arrow-down",
          previous: "fas fa-chevron-left",
          next: "fas fa-chevron-right",
          today: "fas fa-calendar-check",
          clear: "far fa-trash-alt",
          close: "far fa-times-circle"
        }
      },
      item: {
        value: "",
        text: ""
      },
      customerCampaignAllTime: 0,
      customerCampaignToDay: 0,
      customerCampaign1HourBack: 0,
      total_customer_register: 0,
      banner_images: [],
      campaigns: [],
      campaign: {},
      campaigns_option: [],
      regPerDayLineChartData: {
        categories: [],
        series: []
      },
      regPerDayLineChartKey: true,
      campaignLineChartData: {
        categories: [],
        series: []
      },
      campaignLineChartKey: true,
      donutChartData: {
        campaignReceiptRewardDonutSeries: [],
        campaignReceiptRewardLable: [],
        campaignReceiptRewardPointDonutSeries: [],
        campaignReceiptRewardPointLable: [],
        campaignReceiptUnapproveDonutSeries: [],
        campaignReceiptUnapproveLable: [],
        campaignRedeemRewardDonutSeries: [],
        campaignRedeemRewardLable: [],
        receiptColor: [],
        receiptDonutSeries: [],
        receiptLable: []
      },
      donutChartKey: true
    };
  },
  computed: {
    start_date: {
      get() {
        return this.campaign.start_date;
      },
      set(value) {
        this.campaign.start_date = this.formatDate(value);
      }
    },
    end_date: {
      get() {
        return this.campaign.end_date;
      },
      set(value) {
        this.campaign.end_date = this.formatDate(value);
      }
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: `${this.$t("MENU.DASHBOARD.TITLE")}` }
    ]);
    this.getBannerAll();
    this.getCampaignAll();
    // debug chart on resize window
    // window.addEventListener(
    //   "resize",
    //   this.debounce(() => {
    //     setTimeout(() => {
    //       this.regPerDayLineChartKey = !this.regPerDayLineChartKey;
    //       this.campaignLineChartKey = !this.campaignLineChartKey;
    //       this.donutChartKey = !this.donutChartKey;
    //     }, 1000);
    //   })
    // );
  },
  methods: {
    formatDate(value) {
      const date = new Date(value.toString());
      return date.toLocaleDateString(["th-TH"], {
        month: "short",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      });
    },
    onSelect(e) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.setDataGraph(e.value);
          Swal.close();
        }
      });
    },
    filterGraph(campaignId) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: () => {
          Swal.showLoading();
          this.fetchRegPerDayLineChartData(campaignId);
          this.fetchCustomerLineChartData(campaignId);
          this.fetchChartData(campaignId);
          this.render_campaign_line_chart = false;
          this.$nextTick(() => {
            this.render_campaign_line_chart = true;
          });
          Swal.close();
        }
      });
    },
    setDataGraph(campaign_id) {
      this.campaign_id = campaign_id;
      this.campaign = JSON.parse(
        JSON.stringify(
          this.campaigns.filter(data => data.id == this.campaign_id)[0]
        )
      );
      this.from = new Date(this.campaign.start_date);
      this.to = new Date(this.campaign.end_date);
      this.start_date = this.campaign.start_date;
      this.end_date = this.campaign.end_date;
      this.fetchRegPerDayLineChartData(this.campaign_id);
      this.fetchCustomerLineChartData(this.campaign_id);
      this.fetchChartData(this.campaign_id);
      this.render_campaign_line_chart = false;
      this.$nextTick(() => {
        this.render_campaign_line_chart = true;
      });
    },
    fetchRegPerDayLineChartData(id) {
      this.$store
        .dispatch(DASHBOARD_REG_PER_DAY_LINE_CHART_CAMPAIGN, {
          id,
          params: { start_date: this.from, end_date: this.to }
        })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.regPerDayLineChartData = data.data;
            this.regPerDayLineChartKey = !this.regPerDayLineChartKey;
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
          this.isBusy = false;
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error.error}`,
            showConfirmButton: true,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
          this.isBusy = false;
        });
    },
    fetchCustomerLineChartData(id) {
      this.$store
        .dispatch(DASHBOARD_CUSTOMER_LINE_CHART_CAMPAIGN, {
          id,
          params: { start_date: this.from, end_date: this.to }
        })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.campaignLineChartData = data.data;
            this.campaignLineChartKey = !this.campaignLineChartKey;
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
          this.isBusy = false;
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error.error}`,
            showConfirmButton: true,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
          this.isBusy = false;
        });
    },
    fetchChartData(id) {
      this.$store
        .dispatch(DASHBOARD_CHART_CAMPAIGN, {
          id,
          params: { start_date: this.from, end_date: this.to }
        })
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.customerCampaignAllTime = data.data.customerCampaignAllTime;
            this.customerCampaignToDay = data.data.customerCampaignToDay;
            this.customerCampaign1HourBack =
              data.data.customerCampaign1HourBack;
            this.total_customer_register = data.data.total_customer_register;
            this.donutChartData = data.data;
            this.donutChartKey = !this.donutChartKey;
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              showConfirmButton: true,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
          this.isBusy = false;
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error.error}`,
            showConfirmButton: true,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
          this.isBusy = false;
        });
    },
    getBannerAll() {
      this.$store
        .dispatch(GET_ALL, {})
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            for (const index in data.data) {
              if (data.data[index].image) {
                data.data[
                  index
                ].image = `${Config.ADMIN_IMAGE_URL}/${data.data[index].image}`;
              }
            }
            this.banner_images = data.data;
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        });
    },
    getCampaignAll() {
      this.$store
        .dispatch(GET_CAMPAIGN, {})
        .then(({ data }) => {
          if (data.status === "success" && data.data) {
            this.campaigns = data.data;

            if (this.campaigns.length) {
              this.setDataGraph(this.campaigns[0].id);
              this.item.value = this.campaigns[0].id;
              for (const campaign of data.data) {
                this.campaigns_option.push({
                  value: campaign.id,
                  text: campaign.name
                });
              }
            }
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
        })
        .catch(error => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        });
    },
    debounce(func) {
      var timer;
      return event => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, 100, event);
      };
    }
  }
};
</script>

<style>
#carousel-1 .carousel-inner {
  height: auto !important;
}

#carousel-1 .carousel-control-prev,
#carousel-1 .carousel-control-next {
  width: 8% !important;
}
</style>

<style scoped lang="scss">
span {
  font-size: 16px;
}

.status-campaign {
  font-weight: bold;
}

.active {
  color: green;
}

.deactive {
  color: red;
}
</style>
